import React, { useState, useEffect } from "react";
import {
  Button,
  MenuItem,
  Select,
  TextField,
  IconButton,
  Paper,
  Box,
  Grid,
  OutlinedInput,
  Typography,
  Stepper,
  StepConnector,
  Step,
  StepLabel,
  Divider,
} from "@mui/material";
import { Add as AddIcon, Delete as DeleteIcon } from "@mui/icons-material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DatePicker from "react-datepicker";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer";
import Label from "../../../components/Label/Label";
import ModalSign from "../../../components/Modal/Signature/ModalSign";
import * as acts from "../../../redux/pre_processor/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./newBatch.scss";
import { notification } from "../../../constants/notificationMessages";
import constantValues from "../../../constants/constantValues";
import DaysCard from "../../../components/Card/DaysCard";
import Authentication from "../../../components/Modal/PopupModal/PopupModal";
import ProgressBar from "../../../components/ProgressBar";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import styled from "styled-components";
import { preProRoutes } from "../../../routes/routeConstants";

const ColorlibConnector = styled(StepConnector)({
  alternativeLabel: {},
  active: {
    "& $line": {
      borderBottom: "3px solid rgba(0,0,0,0.7)",
      fontWeight: 700,
    },
  },
  completed: {
    "& $line": {
      borderColor: "rgba(0,0,0,0.7)",
      borderBottom: "3px solid rgba(0,0,0,0.7)",
      borderTopWidth: "0px!important",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#B9B9B9",
    borderRadius: 1,
    borderTopWidth: "0px!important",
  },
});

const BatchCreationPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const subject = notification.subjectPre;
  const remark = notification.remarkPre;

  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);

  const tagsUsersAndPdfs = useSelector(
    (state) => state?.prePro?.tagsUsersAndPdfs
  );
  // const savedBatchesData = useSelector(
  //   (state) => state.prePro.savedBatchesData
  // );
  const signUploaded = useSelector(
    (state) => state?.prePro?.isSignatureUploaded
  );

  const fileType = "actual_pdfs";
  const subFolder = localStorage.drugType;

  const {
    // TEXT_EXTRACTION,
    // TEXT_EXTRACT,
    SELECT_EXTRACTION_TIMELINE,
    SELECT_EXTRACTION_USER,
    SELECT_QC_USER,
    SELECT_QC_TIMELINE,
  } = constantValues;

  const [batches, setBatches] = useState(
    // savedBatchesData ||
    [
      {
        projectId: localStorage.getItem("projectId"),
        name: "",
        files: [],
        assignedUser: "",
        assignedQCUser: "",
        extractionTimelineDate: null,
        qcTimelineDate: null,
        autoExtraction: true, // for qc setting autoExtraction true
        subject: subject,
        remark: remark,
      },
    ]
  );
  const [selectedTab, setSelectedTab] = useState(0);
  const [invalidValidationErrorMessage, setInvalidValidationErrorMessage] =
    useState("");
  const [openAuth, setOpenAuth] = useState(false);
  const [openSignPad, setOpenSignPad] = useState(false);

  const [tabValidities, setTabValidities] = useState([]);
  const projectType = localStorage.getItem("projectType");

  useEffect(() => {
    dispatch(acts.clearApiStatus());
    dispatch(acts.clearIsSignatureUploadedStatus());
    dispatch(acts.isSignatureUploaded());
    dispatch(acts.validateUserClear());

    dispatch(
      acts.getTagsUsersAndPdfs(localStorage.projectId, fileType, subFolder)
    );
    // dispatch(acts.getSavedBatchesData(localStorage.projectId));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTabValidities(new Array(batches.length).fill(false));
  }, [batches]);

  // useEffect(() => {
  //   if (savedBatchesData && savedBatchesData.length > 0) {
  //     setBatches([...savedBatchesData]);
  //   }
  // }, [savedBatchesData]);

  const handleTabValidation = () => {
    let isValid = true;
    const updatedValidities = [...tabValidities];

    batches.forEach((batch, index) => {
      // Validate each tab

      if (
        batch.name.trim() === "" ||
        batch.files.length === 0 ||
        tagsUsersAndPdfs.tags.length !== batch.files.length ||
        batch.files.every((file) => !file.pdfName === "")
      ) {
        isValid = false;
        updatedValidities[index] = true; // Mark the tab as invalid
      }

      if (
        projectType === "free_form" &&
        (batch.assignedQCUser === "" || !batch.qcTimelineDate)
      ) {
        isValid = false;
        updatedValidities[index] = true; // Mark the tab as invalid
      }

      if (
        projectType === "template_driven" &&
        (batch.assignedUser === "" || !batch.extractionTimelineDate)
      ) {
        isValid = false;
        updatedValidities[index] = true; // Mark the tab as invalid
      }

      if (
        projectType === "both" &&
        (batch.assignedQCUser === "" ||
          !batch.qcTimelineDate ||
          batch.assignedUser === "" ||
          !batch.extractionTimelineDate)
      ) {
        isValid = false;
        updatedValidities[index] = true; // Mark the tab as invalid
      }

      if (isValid === true) {
        updatedValidities[index] = false;
      }
    });
    setTabValidities(updatedValidities);
    return isValid;
  };

  const onClick = (event, action) => {
    event.preventDefault();
    const isValid = handleTabValidation();
    if (isValid) {
      if (action === "continue") {
        if (signUploaded?.isSignatureUploaded !== undefined) {
          if (signUploaded?.isSignatureUploaded === false) {
            setOpenSignPad(true);
          }
          if (signUploaded?.isSignatureUploaded === true) {
            setOpenAuth(true);
          }
        }
      }

    } else {
    }
  };

  const handleUserPermission = () => {
    dispatch(acts.createBatches(batches, projectType));
  };

  const handleEsignDialogBoxClose = () => {
    setOpenSignPad(false);
    setTimeout(() => {
      dispatch(acts.isSignatureUploaded());
    }, 1500);
  };

  const handleAddBatch = () => {
    setBatches([
      ...batches,
      {
        projectId: localStorage.getItem("projectId"),
        name: "",
        files: [],
        assignedUser: "",
        assignedQCUser: "",
        extractionTimelineDate: null,
        qcTimelineDate: null,
        autoExtraction: true, // for qc setting autoExtraction true
        subject: subject,
        remark: remark,
      },
    ]);
    setSelectedTab(batches.length);
  };

  const handleRemoveBatch = (index) => {
    const updatedBatches = [...batches];
    updatedBatches.splice(index, 1);
    setBatches(updatedBatches);
    setSelectedTab(Math.min(index, updatedBatches.length - 1));
  };

  const handleNameInputChange = (index, value) => {
    setInvalidValidationErrorMessage("");
    if (/[^a-zA-Z0-9_ -]/.test(value)) {
      setInvalidValidationErrorMessage(
        notification.invalidValidationErrMsgBatch
      );
    } else {
      const updatedBatches = [...batches];
      updatedBatches[index]["name"] = value;
      setBatches(updatedBatches);
    }
  };

  const handleSelectUserChange = (type, index, value) => {
    const updatedBatches = [...batches];
    updatedBatches[index][
      type === "template_driven" ? "assignedUser" : "assignedQCUser"
    ] = value;
    setBatches(updatedBatches);
  };

  const handleDateChange = (type, index, timelineDate) => {
    const updatedBatches = [...batches];
    if (type === "template_driven") {
      updatedBatches[index].extractionTimelineDate = timelineDate;
      setBatches(updatedBatches);
    } else {
      updatedBatches[index].qcTimelineDate = timelineDate;
      setBatches(updatedBatches);
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleChangeFile = (index, cardIndex, pdfName, pdfPath, tagName) => {
    const updatedBatches = [...batches];
    updatedBatches[index].files[cardIndex] = {
      tagName: tagName,
      pdfPath: pdfPath,
      pdfName: pdfName,
    };
    setBatches(updatedBatches);
  };

  // const handleCheckBoxClick = (index, event) => {
  //   const updatedBatches = [...batches];
  //   updatedBatches[index]["autoExtraction"] = event.target.checked;
  //   setBatches(updatedBatches);
  // };

  const handleCloseSnackbar = (key) => {
    if (key === "success") {
      // navigate("/pre-processor-dashboard");
      navigate(`/${preProRoutes.preProDashboard}`) 
    }
    dispatch(acts.clearApiStatus());
  };

  return (
    <>
      <Header />

      <div className="batch-creation-container">
        <div style={{ display: "nonne" }}></div>
        <Typography className="project-batch-header">
          {localStorage.projectName + " - " + localStorage.drugType}
        </Typography>

        <Stepper connector={<ColorlibConnector />}>
          <Step key="Map Data" className="stepper-wrap-label">
            <StepLabel>Batch Creation</StepLabel>
          </Step>
        </Stepper>
      </div>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ flex: 1 }} // To make tabs flexible and take up remaining space
        >
          {batches.map((batch, index) => (
            <Tab
              key={index}
              label={batch?.name ? batch?.name : "Batch Name"}
              style={{
                color: tabValidities[index] ? "red" : "inherit",
              }}
            />
          ))}
        </Tabs>

        <Box sx={{ width: "160px", paddingRight: "10px" }}>
          {" "}
          {/* Fixed width of 200px */}
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleAddBatch}
            fullWidth
          >
            Add Batch
          </Button>
        </Box>
      </Box>
      {tagsUsersAndPdfs &&
        tagsUsersAndPdfs?.tags?.length > 0 &&
        batches.map((batch, index) => (
          <Paper
            key={index}
            hidden={selectedTab !== index}
            elevation={3}
            style={{ padding: "5px 10px", marginBottom: "5px" }}
          >
            {/* <Grid container spacing={2}> */}
            {/* Batch Name */}
            <Grid container item spacing={2} md={12}>
              {/* Select QC User */}
              <Grid item xs={10} sm={6} md={4}>
                <div className="input-wrap">
                  <Label text="Batch Name" fontSize={16} fontWeight={500} />
                  <TextField
                    error={invalidValidationErrorMessage !== ""}
                    helperText={invalidValidationErrorMessage}
                    fullWidth
                    size="small"
                    value={batch.name}
                    onChange={(e) =>
                      handleNameInputChange(index, e.target.value)
                    }
                  />
                </div>
              </Grid>

              {/* Remove Button */}
              <Grid
                item
                xs={2}
                sm={6}
                md={8}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton
                  onClick={() => handleRemoveBatch(index)}
                  size="large"
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>

              <Grid container item spacing={2} md={12}>
                {/* Select QC User */}
                <Grid item xs={12} sm={6} md={3}>
                  <div className="input-wrap">
                    <Label
                      text={SELECT_QC_USER}
                      fontSize={16}
                      fontWeight={500}
                    />
                    <Select
                      size="small"
                      className="field-style"
                      fullWidth
                      value={batch.assignedQCUser}
                      onChange={(event) =>
                        handleSelectUserChange(
                          "free_form",
                          index,
                          event.target.value
                        )
                      }
                      input={<OutlinedInput />}
                      disabled={projectType === "template_driven"}
                    >
                      {tagsUsersAndPdfs?.users?.map((option, idx) => (
                        <MenuItem key={idx} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>

                {/* QC Timeline DatePicker */}
                <Grid item xs={12} sm={6} md={3}>
                  <div className="timeline-date-picker">
                    <Label
                      text={SELECT_QC_TIMELINE}
                      fontSize={16}
                      fontWeight={500}
                    />
                    <DatePicker
                      className={`Date-picker ${
                        projectType === "template_driven"
                          ? "date-picker-disabled"
                          : ""
                      }`}
                      variant="outlined"
                      selected={
                        batch?.qcTimelineDate
                          ? new Date(batch.qcTimelineDate)
                          : null
                      }
                      onChange={(date) =>
                        handleDateChange("free_form", index, date)
                      }
                      minDate={new Date()}
                      showDisabledMonthNavigation
                      disabled={projectType === "template_driven"}
                    />
                  </div>
                </Grid>
                {/* </Grid> */}

                <Divider />

                {/* Second Row */}
                {/* <Grid container item spacing={2} md={12}> */}
                {/* Select Extraction User */}
                <Grid item xs={12} sm={6} md={3}>
                  <div className="input-wrap">
                    <Label
                      text={SELECT_EXTRACTION_USER}
                      fontSize={16}
                      fontWeight={500}
                    />
                    <Select
                      size="small"
                      className="field-style"
                      fullWidth
                      value={batch.assignedUser}
                      onChange={(event) =>
                        handleSelectUserChange(
                          "template_driven",
                          index,
                          event.target.value
                        )
                      }
                      input={<OutlinedInput />}
                      disabled={projectType === "free_form"}
                    >
                      {tagsUsersAndPdfs?.users?.map((option, idx) => (
                        <MenuItem key={idx} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>

                {/* Extraction Timeline DatePicker */}
                <Grid item xs={12} sm={6} md={3}>
                  <div className="timeline-date-picker">
                    <Label
                      text={SELECT_EXTRACTION_TIMELINE}
                      fontSize={16}
                      fontWeight={500}
                    />
                    <DatePicker
                      className={`Date-picker ${
                        projectType === "free_form"
                          ? "date-picker-disabled"
                          : ""
                      }`}
                      variant="outlined"
                      selected={
                        batch?.extractionTimelineDate
                          ? new Date(batch.extractionTimelineDate)
                          : null
                      }
                      onChange={(date) =>
                        handleDateChange("template_driven", index, date)
                      }
                      minDate={new Date()}
                      showDisabledMonthNavigation
                      disabled={projectType === "free_form"}
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>

            {/* // Pdf Uploader */}

            <Box className="uploadpdf-main-container">
              <Box className="uploadpdf-card-container">
                <Grid
                  container
                  spacing={1}
                  // xs={4} sm={4} md={4}
                >
                  {tagsUsersAndPdfs?.tags?.map((tagName, cardIndex) => {
                    return (
                      <Grid
                        key={index}
                        item
                        xs={6}
                        sm={4}
                        md={4}
                        className="pdfcard"
                      >
                        <DaysCard
                          tagName={tagName}
                          actualFilesListData={tagsUsersAndPdfs?.pdfs}
                          handleChange={(
                            cardIndex,
                            file_name,
                            file_url,
                            tagName
                          ) =>
                            handleChangeFile(
                              index,
                              cardIndex,
                              file_name,
                              file_url,
                              tagName
                            )
                          }
                          cardIndex={cardIndex}
                          selectedFiles={batches[index].files}
                          // uploadedBatchPdfs={uploadedBatchPdfs}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </Box>
          </Paper>
        ))}

      {apiStatus.loading && <ProgressBar />}

      {/* sign auth */}
      {openAuth && (
        <Authentication
          openAuth={openAuth}
          handleClose={() => setOpenAuth(false)}
          handleUserPermission={handleUserPermission}
        />
      )}
      {openSignPad && (
        <ModalSign
          openSignPad={openSignPad}
          handleEsignDialogBoxClose={() => handleEsignDialogBoxClose(false)}
        ></ModalSign>
      )}

      {apiStatus?.next && (
        <CustomizedSnackbars
          severity="success"
          state={true}
          text={apiStatus?.message}
          handleClose={() => handleCloseSnackbar("success")}
        />
      )}

      {apiStatus?.apiError && (
        <CustomizedSnackbars
          severity="error"
          state={true}
          text={apiStatus?.message}
          handleClose={() => handleCloseSnackbar("error")}
        />
      )}

      <Footer
        isPrevious={false}
        onHandleClick={(event, action) => onClick(event, action)}
      />
    </>
  );
};

export default BatchCreationPage;
